@if (!loading) {
<div class="modal-wrapper">
  <div class="modal-header modal-header--custom">
    <div class="modal-header__title">
      <div class="modal-icon"><mat-icon>person_add</mat-icon></div>
      <h4>Add Member</h4>
    </div>
    <button mat-icon-button class="modal-close-btn" (click)="activeModal.close('close')" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body modal-form-body">
    <form [formGroup]="entryForm" novalidate>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Member Email</mat-label>
        <mat-select formControlName="memberEmail" required>
          @for (user of userList; track user.email) {
            <mat-option [value]="user.email">{{ user.email }}</mat-option>
          }
        </mat-select>
        @if (entryForm.controls['memberEmail'].hasError('required')) {
          <mat-error>Email is required</mat-error>
        }
      </mat-form-field>
    </form>
  </div>

  <div class="modal-footer modal-footer--custom">
    <button mat-flat-button color="primary" class="modal-action-btn"
            [disabled]="entryForm.invalid"
            (click)="onCreate_Update()">
      <mat-icon>person_add</mat-icon> Add Member
    </button>
  </div>
</div>
}

@if (loading) {
  <app-loading-spinner></app-loading-spinner>
}
